export const extractYouTubeVideoURL = (url: string): string | null => {
  try {
    const urlObj = new URL(url)
    const hostname = urlObj.hostname.replace('www.', '')

    if (hostname.includes('youtube.com') || hostname.includes('youtube-nocookie.com')) {
      // Check for /embed/VIDEO_ID
      const embedMatch = url.match(/\/embed\/([a-zA-Z0-9_-]{11})/)
      if (embedMatch) return `https://i.ytimg.com/vi/${embedMatch[1]}/sddefault.jpg`

      const vParam = urlObj.searchParams.get('v')
      if (vParam) return `https://i.ytimg.com/vi/${vParam}/sddefault.jpg`

      const vMatch = url.match(/\/v\/([a-zA-Z0-9_-]{11})/)
      if (vMatch) return `https://i.ytimg.com/vi/${vMatch[1]}/sddefault.jpg`
    }

    if (hostname === 'youtu.be') {
      const pathMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/)
      if (pathMatch) return `https://i.ytimg.com/vi/${pathMatch[1]}/sddefault.jpg`
    }

    return null
  } catch (e) {
    console.error('Error extracting YouTube video ID:', e)
    return null
  }
}
